import { useDelete } from '../../../../../../../api/react-query';
export function useMenuConfigDelete({ params }) {
  const {
    mutateAsync: deleteConfig,
    isLoading: isDeleting,
    error,
  } = useDelete({
    url: 'config/empportalMenu/config',
    params: params,
  });

  return {
    deleteConfig,
    isDeleting,
    error,
  };
}
